import { isBookingAnswered } from "@/forms/assignment-reference-bookings-form";
import { Button } from "@msuite/ui/button";
import { useTranslation } from "@msuite/ui/localization";
import { guardArray } from "@msuite/utils/array";
import type { AssignmentReferenceBookingsSchema } from "@msuite/utils/schemas";
import { useFormContext, useWatch } from "react-hook-form";
import { useAssignmentReferenceBookingsModalContext } from "./context";

/**
 * The modal's submit. The host saves only once every booking has its answer — accepted, rejected
 * or corrected — as the native review asks, so a booking left unanswered or still open in its
 * inputs holds the button back. The partner submits whenever it likes. It watches the bookings on
 * its own, so an answer re-renders the button rather than the modal around it.
 */
export function AssignmentReferenceBookingsSubmitButton() {
	/** Context */
	const methods = useFormContext<AssignmentReferenceBookingsSchema>();
	const { role } = useAssignmentReferenceBookingsModalContext();

	/** Hooks */
	const { t } = useTranslation();
	const bookings = useWatch({ control: methods.control, name: "bookings" });

	/** Computed */
	const hasUnansweredBookings =
		role === "host" &&
		guardArray(bookings).some((booking) => !isBookingAnswered(booking.adjustment?.result));

	/** Render */
	return (
		<Button
			variant="primary"
			type="submit"
			isDisabled={hasUnansweredBookings}
			isLoading={methods.formState.isSubmitting}
		>
			{t("general.submit")}
		</Button>
	);
}
